<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SDW06C/tc-custom/9780061755149.jpg?1728851631962" alt="This image is the cover for the book Taking Heat"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Taking Heat
      </h1>
      <p class="bookDescription body article font2">
        <p>The early years of the twenty-first century were a tumultuous time in America. The country faced a hotly contested presidential election, the largest terrorist attack in the nation's history, and the early stages of war. Through it all, President George W. Bush surrounded himself with a handful of close advisers. During this time the man beside the President was Ari Fleischer, his press secretary and one of his most trusted confidants. In this role, Fleisher was present for every decision and became an eyewitness to history.</p><p>In this riveting account, Fleischer goes behind the scenes as he recalls his experiences in the West Wing. Through the ups and downs of this time, he took the heat, fielded the questions, and brought the President's message into living rooms around the world.</p><p>In <i>Taking Heat</i>, Fleischer, for the first time, gives his perspective on:</p>The 2000 election, from the recounts to the transition to powerSeptember 11, 2001, its aftermath, and the anthrax scareThe pressure-filled buildup to the war in Iraq and the President's thoughts as the war beganLife in the White House, from learning to adjust to the pace of the West Wing and his early briefings to his relationship with the pressThe White House press corps, who they are, and how they report the newsThe factors that led to his decision to leave Washington behind.<p>This is the story of the men and women of the White House press corps and the cornerstones of democracy: freedom of speech and the freedom of the press. Fleischer presents an in-depth, insider's view on the Washington political arena from a perspective few have seen.</p><p>Fleischer writes of his belief that the press has a bias in Washington. It's not a question of partisanship or press-driven ideology. Instead, it's a focus on conflict, particularly if it's a conflict they can attach to the President. It's the nature of the White House press corps, regardless of who's in power. The members of the White House press corps are masters at being devil's advocate, able to take with passion the opposite side of whatever issue the President supports. Fleischer's job was to calmly field their questions, no matter how pointed.</p><p><i>Taking Heat</i> is an introspective exploration of the top political events in the first half of the Bush administration, as well as the candid observations of a professional who stood in the bright lights of the world stage.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ari Fleischer
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?34e685fb